export default "<p>mobile-registration works!</p>\r\n";